/* eslint-disable max-len */
import React from 'react'

const Roadmap = () => (
    <div className="roadmap-wrapper" id="roadmap">
        <div className="roadmap-title">
            <h2>MacPunks Roadmap</h2>
        </div>
        <div className="roadmap-container">
            <div className="border" />
            <div className="window" id="system-window" data-is-open="data-is-open">
                <div className="title-bar">
                    <button className="close" type="button"><span className="hidden">Close</span></button>
                    <h2 className="title">PRE-LAUNCH</h2>
                    <button className="resize" type="button"><span className="hidden">Resize</span></button>
                </div>
                <div className="window__pane">
                    <p>
                        <b>Community-First:</b>
                        {' '}
                        We have one simple goal in mind when starting Macpunks: to adopt a community-first approach that acts as an inspiring place for all our holders. That’s why our major objective is built around the idea of how we can bring value to our community. As a community-driven project we will organize exciting events and maintain 100% transparency at all times.
                    </p>
                    <p>
                        <b>Collabs and Partners:</b>
                        {' '}
                        The metaverse is a space where anything can be done! Anything can be created! That’s why we will seek out and encourage exciting partnerships with other popular brands to create a unique space where the community can discuss new opportunities for growth and business ideas.
                    </p>
                </div>
            </div>

            <div className="window" id="system-window" data-is-open="data-is-open">
                <div className="title-bar">
                    <button className="close" type="button"><span className="hidden">Close</span></button>
                    <h2 className="title">PHASE 1</h2>
                    <button className="resize" type="button"><span className="hidden">Resize</span></button>
                </div>
                <div className="window__pane">
                    <p>
                        <b>Idea Factory:</b>
                        {' '}
                        As we began brainstorming a roadmap, we knew we wanted to create a space where we could generate and bring new ideas into fruition for all our members. That’s why when you mint a Macpunk NFT you will have exclusive access to our Idea Factory where other entrepreneurs can communicate ideas with our team of professionals.
                    </p>
                </div>
            </div>

            <div className="window" id="system-window" data-is-open="data-is-open">
                <div className="title-bar">
                    <button className="close" type="button"><span className="hidden">Close</span></button>
                    <h2 className="title">PHASE 2</h2>
                    <button className="resize" type="button"><span className="hidden">Resize</span></button>
                </div>
                <div className="window__pane">
                    <p>
                        <b>Funding Web 3.0:</b>
                        {' '}
                        Once our community has established itself, we will start the exciting process of funding ideas created by our holders.
                        {' '}
                    </p>
                </div>
            </div>

            <div className="window" id="system-window" data-is-open="data-is-open">
                <div className="title-bar">
                    <button className="close" type="button"><span className="hidden">Close</span></button>
                    <h2 className="title">PHASE 3</h2>
                    <button className="resize" type="button"><span className="hidden">Resize</span></button>
                </div>
                <div className="window__pane">
                    <p>
                        <b>Release of Road Map 2.0:</b>
                        {' '}
                        After the completion of Road Map 1.0, we will unlock the next stage of the road map. Here we will focus more on various real-life utility aspects and metaverse opportunities.
                    </p>
                </div>
            </div>
        </div>
    </div>

)

export default Roadmap
